export default __webpack_public_path__ + "static/UX-Portfolio-5e922744153953fb2d2c2c6899e20ee5.pdf";